import { Input } from "antd";
import { getIn, useFormikContext } from "formik";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';


const TextInput = (props) => {
    const { name, size = 'middle', prefix = null, placeholder, label, disabled = false, suffix = null, type = 'text', className = '', labelClassName = '', handleChange = () => { }, handleKeyDown = () => { }, wrapperClassName = '', isRequired=false, min = "0", step = "0.01" } = props
    const { values, handleBlur, errors, touched, setFieldValue } = useFormikContext();
    const error = getIn(errors, name);
    const isTouched = getIn(touched, name);
    const value = getIn(values, name);
    return (
        <div className={`relative ${wrapperClassName}`}>
            {label && <label className={labelClassName} htmlFor={name}>{label} {isRequired && <span className='text-red-600'>*</span>}</label>}
            {
                type === "password" ? (
                 <Input.Password
                    id={name}
                    name={name}
                    size={size}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => {
                        setFieldValue(name, e.target.value);
                        handleChange(e.target.value);
                    }}
                    onBlur={handleBlur}
                    status={error && isTouched ? "error" : ""}
                    prefix={prefix}
                    suffix={suffix}
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    className={className}                    
                 />
                ) :
                (
                 <Input
                    id={name}
                    name={name}
                    size={size}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => {
                        setFieldValue(name, e.target.value);
                        handleChange(e.target.value);
                    }}
                    onBlur={handleBlur}
                    status={error && isTouched ? "error" : ""}
                    prefix={prefix}
                    suffix={suffix}
                    disabled={disabled}
                    type={type}
                    style={{ width: "100%" }}
                    className={className}
                    onKeyDown={(e) => {
                        handleKeyDown(e);
                    }}
                    min={min}
                    step={step}
                 />
                )
            }
            {error && isTouched && (
                <span className={`input-error`}>{error}</span>
            )}
        </div>
    );
}

export default TextInput;